import { createSelector } from 'reselect'
import { isMobileSelector } from 'reduxModules/app/selectors'
import { authInfoSelector } from 'reduxModules/auth/selectors'

export const certificatesSelector = (state) => state.certificates.list
export const certificatesStatusSelector = (state) => state.certificates.status

export const certificatesReselector = createSelector(
  [
    certificatesSelector,
    certificatesStatusSelector,
    authInfoSelector,
    isMobileSelector
  ],
  (certificates, status, authInfo, isMobile) => ({
    certificates,
    status,
    isMobile,
    // Prefill for the claim form (FR-3): account name when present
    defaultName: [authInfo.firstName, authInfo.lastName]
      .filter(Boolean)
      .join(' ')
  })
)
